import { QuestionMethods } from '../questionMethods.types';
import {
	RenderedMatrixQuestion,
	MatrixGivenAnswer,
} from './matrixMethods.types';

export const getMatrixAnswerListItems: QuestionMethods<
	RenderedMatrixQuestion,
	MatrixGivenAnswer
>['getAnswerListItems'] = ({ question, givenAnswers, answerListData }) => {
	const answerData = answerListData.matrix?.[question.id];
	if (answerData == null) return [];

	const givenAnswer = givenAnswers.matrix.get(question.id);
	if (givenAnswer == null) return [];

	const items = question.columns
		.filter((column) => answerData.columnIds.includes(column.id))
		.flatMap((column) => {
			return question.rows.filter((row) => {
				return givenAnswer.rows.some(
					(givenRow) =>
						givenRow.rowId === row.id && givenRow.columnId === column.id,
				);
			});
		})
		.map((row) => {
			return {
				title: row.title,
				explanation: row.explanation,
			};
		});

	return items;
};
